import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

    interface Props {
        text: string | null;
        color?: string;
        solid?: boolean;
        size?: 'sm' | 'md';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseBadge',
  props: {
    text: {},
    color: { default: 'primary' },
    solid: { type: Boolean },
    size: { default: 'md' }
  },
  setup(__props: any) {

    const props = __props;

    const backgroundColor = computed(() => {
        const alpha = props.solid ? 1 : 0.1;
        return {
            background: `rgba(var(--${props.color}), ${alpha})`,
        };
    });

    const textColor = computed(() => {
        return {
            color: props.solid ? `rgba(255,255,255,1)` : `rgba(var(--${props.color}), 1)`,
        };
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["focus-visible:border-ring focus-visible:ring-ring/50 inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-lg font-semibold whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3", [
            __props.size === 'sm' ? 'px-1.5 py-0.5 text-2xs' : 'px-2 py-0.5 text-xs',
        ]]),
    style: _normalizeStyle(backgroundColor.value)
  }, [
    _createElementVNode("span", {
      style: _normalizeStyle(textColor.value)
    }, [
      _createTextVNode(_toDisplayString(__props.text) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ], 6))
}
}

})